import { render, staticRenderFns } from "./Connections.vue?vue&type=template&id=f4c4451e&"
import script from "./Connections.vue?vue&type=script&lang=js&"
export * from "./Connections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports